export const MASTER_PARTNER_DEALERS = "MASTER_PARTNER_DEALERS";
export const MASTER_PARTNER_HISTORY = "MASTER_PARTNER_HISTORY";
export const MASTER_PARTNER_SCORING = "MASTER_PARTNER_SCORING";
export const MASTER_PARTNER_DASHBOARD = "MASTER_PARTNER_DASHBOARD";
export const MASTER_PARTNER_WRITE = "MASTER_PARTNER_WRITE";
export const MASTER_PARTNER_READ = "MASTER_PARTNER_READ";
export const MASTER_PARTNER_BANKS_READ = "MASTER_PARTNER_BANKS_READ";
export const MASTER_PARTNER_BANKS_WRITE = "MASTER_PARTNER_BANKS_WRITE";
export const MASTER_PARTNER_SELFPARTNER_READ = "MASTER_PARTNER_SELFPARTNER_READ";
export const MASTER_PARTNER_SELFPARTNER_WRITE = "MASTER_PARTNER_SELFPARTNER_WRITE";
export const MASTER_PARTNER_HIERARCHIES_READ = "MASTER_PARTNER_HIERARCHIES_READ";
export const MASTER_PARTNER_HIERARCHIES_WRITE = "MASTER_PARTNER_HIERARCHIES_WRITE";
export const MASTER_PARTNER_MENU_SETTINGS = "MASTER_PARTNER_MENU_SETTINGS";
export const MASTER_PARTNER_MENU_LOGS = "MASTER_PARTNER_MENU_LOGS";
export const MASTER_PARTNER_SYNCHRONIZATION_HISTORY = "MASTER_PARTNER_SYNCHRONIZATION_HISTORY";
export const MASTER_PARTNER_SHAREHOLDER_PHONE  = "MASTER_PARTNER_SHAREHOLDER_PHONE";
export const MASTER_PARTNER_WARNING_AREA = "MASTER_PARTNER_WARNING_AREA";
export const CLIENT_PERSONWORKPLACES_READ = "CLIENT_PERSONWORKPLACES_READ";
export const CLIENT_PERSONWORKPLACES_WRITE = "CLIENT_PERSONWORKPLACES_WRITE";